import type { NullableChartDataPoint } from '../types';

export const getChartSeries = (data: NullableChartDataPoint[]): string[] => {
  const series = new Set<string>();
  data.forEach(point => {
    Object.entries(point.values).forEach(([key, value]) => {
      if (
        key !== 'name' &&
        typeof value === 'number' &&
        Number.isFinite(value)
      ) {
        series.add(key);
      }
    });
  });
  return Array.from(series);
};

// Visx's scale maps null to zero. NaN makes its defined predicate leave a gap.
export const getChartMeasurement = (
  values: NullableChartDataPoint['values'],
  series: string
): number => {
  const value = values[series];
  return typeof value === 'number' && Number.isFinite(value) ? value : NaN;
};

export const getIsolatedChartMeasurements = (
  data: NullableChartDataPoint[],
  series: string
): Set<NullableChartDataPoint['values']> => {
  const measured = data.map(point =>
    Number.isFinite(getChartMeasurement(point.values, series))
  );
  return new Set(
    data
      .filter(
        (_, index) =>
          measured[index] && !measured[index - 1] && !measured[index + 1]
      )
      .map(point => point.values)
  );
};
